import React from 'react'
import Fragment from '../common/fragment'


function FragmentAH(props) {
  return (
    <Fragment pos="h" {...props}>
      <p className="interact interactive" id="anchor-zoom-b">
¿Salamanca es un valle?, ¿Chernobyl, Ventanas, Hiroshima, Nagasaki, Bhopal,
Fukushima?
      </p>
    </Fragment>
  )
}


export default FragmentAH
